import { Dispatch, SetStateAction } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getIndividualStore } from 'api/admin/stores/getIndividualStore';
import { TransportationPreferences } from 'constants/store/storeSettings';
import { ApiError } from 'types/api';

export const useTransportationPreference = ({
  storeIds,
  setError,
}: {
  storeIds: number[];
  setError: Dispatch<SetStateAction<string>>;
}) => {
  const queryKey = ['transportationPreference', { storeIds }];
  const { data: transportationPreference, isLoading: isLoadingTransportationPreference } = useQuery<
    unknown,
    ApiError,
    TransportationPreferences | null
  >(
    queryKey,
    async () => {
      const storeValues = await Promise.all(
        storeIds.map(async (id) => await getIndividualStore(id)),
      ).then((stores) => stores.map(({ data }) => data.store.settings.transportationPreference));

      // we set null if stores of this business have different values
      return storeValues.every((value) => value === storeValues[0]) ? storeValues[0] : null;
    },
    {
      onError: (error) => {
        setError(error?.response?.data?.error || '');
      },
    },
  );

  return {
    transportationPreference,
    isLoadingTransportationPreference,
    queryKey,
  };
};
